export default __webpack_public_path__ + "static/media/sennheisser@2x.c49bcd3f.jpg";